import { useEffect, useState } from "react";
import { api } from "../../lib/api";
import { toast } from "sonner";
import { RefreshCw, FileText, Loader2 } from "lucide-react";

const gbp = (n) => "£" + Math.round(Number(n || 0)).toLocaleString("en-GB");
const dateGB = (d) => d ? new Date(d).toLocaleDateString("en-GB", { day: "2-digit", month: "short", year: "numeric" }) : "—";

export function RefundedPanel({ onOpenBooking }) {
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);

  const load = async () => {
    setLoading(true);
    try {
      const r = await api.get("/admin/bookings");
      setRows((r.data.items || []).filter(b => b.status === "refunded"));
    } catch { toast.error("Could not load"); }
    setLoading(false);
  };
  useEffect(() => { load(); }, []);

  return (
    <div data-testid="refunded-panel">
      <div className="flex items-end justify-between gap-3 flex-wrap mb-4">
        <div>
          <div className="label-eyebrow">Admin only</div>
          <h2 className="text-2xl font-black text-[#12263A]">Refunded jobs</h2>
          <p className="text-sm text-[#6B7280] mt-1 max-w-2xl">Every booking that has been refunded. Open a file to see the refund history and paid amounts.</p>
        </div>
        <button data-testid="refunded-refresh" onClick={load} className="de-btn-secondary inline-flex items-center gap-2 text-xs">
          <RefreshCw size={14} /> Refresh
        </button>
      </div>

      {loading ? (
        <div className="py-10 text-center text-sm text-[#6B7280]"><Loader2 className="animate-spin inline mr-2" size={14} /> Loading refunded jobs…</div>
      ) : rows.length === 0 ? (
        <div className="py-14 text-center text-sm text-[#9CA3AF] border border-dashed border-[#E5E7EB]" data-testid="refunded-empty">
          <FileText size={22} className="mx-auto mb-2 opacity-40" />
          No refunded jobs on record.
        </div>
      ) : (
        <div className="border border-[#E5E7EB] bg-white overflow-x-auto">
          <table className="w-full text-sm">
            <thead>
              <tr className="bg-[#F8F6F2] text-left text-[11px] uppercase tracking-widest text-[#6B7280]">
                <th className="px-3 py-2.5">Reference</th>
                <th className="px-3 py-2.5">Client</th>
                <th className="px-3 py-2.5">Postcode</th>
                <th className="px-3 py-2.5 text-right">Contract total</th>
                <th className="px-3 py-2.5">Refunded on</th>
              </tr>
            </thead>
            <tbody>
              {rows.map(b => (
                <tr key={b.reference} data-testid={`refunded-row-${b.reference}`}
                  onClick={() => onOpenBooking(b.reference)}
                  className="border-t border-[#E5E7EB] hover:bg-[#FBF3EC] cursor-pointer">
                  <td className="px-3 py-2.5 font-black text-[#C79A3B]">{b.reference}</td>
                  <td className="px-3 py-2.5">
                    <div className="font-medium text-[#12263A]">{b.name || "—"}</div>
                    <div className="text-xs text-[#6B7280]">{b.email || "—"}</div>
                  </td>
                  <td className="px-3 py-2.5 text-[#6B7280]">{b.postcode || "—"}</td>
                  <td className="px-3 py-2.5 text-right tabular-nums">{gbp(b.total_inc_vat)}</td>
                  <td className="px-3 py-2.5 text-xs text-[#6B7280]">{dateGB(b.updated_at || b.created_at)}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
